import { StyleSheet, Text, View } from "@react-pdf/renderer";
import {variables} from '../variables'

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: "row",
    marginTop: 24,
  },
  reportTitle: {
    color: variables.textColor,
    letterSpacing: 2,
    fontSize: 25,
    textAlign: "center",
    textTransform: "capitalize",
  },
});

const PdfTitle = ({ title }) => {
  return (
    <View style={styles.titleContainer}>
      <Text style={styles.reportTitle}>{title}</Text>
    </View>
  );
};

export default PdfTitle;